<script setup>
</script>

<template>
  <div class="legal-page">
    <div class="container">
      <div class="legal-content">
        <h1 class="page-title">服务条款</h1>
        
        <section>
          <h2>一、协议的确认与适用范围</h2>
          <p>欢迎您使用 水芯智能芯片服务平台（以下简称“水芯”或“本平台”）。</p>
          <p>本协议是您与水芯运营主体之间，就您访问、注册、登录及使用水芯平台所订立的协议。</p>
          <p>您在本平台完成注册、登录、提交订单申请或实际使用平台服务的，即视为您已阅读、理解并同意本协议的全部内容。</p>
        </section>

        <section>
          <h2>二、平台服务内容说明</h2>
          <p>水芯为用户提供以下服务：</p>
          <ul>
            <li>芯片产品信息与技术参数展示</li>
            <li>芯片型号查询与应用参考</li>
            <li>订单申请与采购需求提交服务</li>
          </ul>
        </section>

        <section>
          <h2>三、订单性质与交易说明（重点条款）</h2>
          <ol>
            <li>用户在平台提交的“订单”或“下单申请”，仅表示用户向平台提交采购需求或交易意向。</li>
            <li>订单提交成功后，订单状态为“待确认”，不代表交易已经成立或完成。平台运营人员将基于订单信息与用户进行人工沟通，确认包括但不限于价格、数量、交期、付款方式等关键交易要素。最终交易是否成立及成交内容，以双方确认结果为准。</li>
          </ol>
        </section>

        <section>
          <h2>四、支付与结算说明</h2>
          <ol>
            <li>当前阶段，水芯平台不提供在线支付功能。</li>
            <li>实际付款事宜由平台运营人员与用户线下另行确认。</li>
            <li>因线下支付或结算产生的相关权利义务，由交易双方依据确认内容自行履行。</li>
          </ol>
        </section>

        <section>
          <h2>五、用户注册与账号管理</h2>
          <ol>
            <li>用户应提供真实、合法、有效的注册信息。</li>
            <li>用户应妥善保管账号信息，因自身原因造成的损失由用户自行承担。</li>
            <li>水芯有权对异常注册、异常操作账号进行限制或终止服务。</li>
          </ol>
        </section>

        <section>
          <h2>六、用户行为规范</h2>
          <p>用户在使用本平台过程中，不得从事以下行为：</p>
          <ul>
            <li>恶意刷单、刷询价、批量爬取平台数据</li>
            <li>擅自复制、传播或利用平台价格信息、规则或系统结果</li>
            <li>以任何方式干扰平台正常运行</li>
            <li>利用平台从事违法违规活动</li>
          </ul>
          <p>如用户存在上述行为，水芯有权采取限制、暂停或终止服务等措施。</p>
        </section>

        <section>
          <h2>七、知识产权声明</h2>
          <p>本平台所涉及的系统、页面设计、数据整合成果、报价规则及相关内容，其知识产权均归水芯或合法权利人所有。未经授权，任何个人或组织不得使用。</p>
        </section>

        <section>
          <h2>八、风险提示与免责条款</h2>
          <ol>
            <li>芯片价格受市场、库存、交期等多种因素影响，可能存在波动。</li>
            <li>用户基于平台信息作出的商业决策，其风险由用户自行承担。</li>
            <li>因不可抗力或系统维护造成的服务中断，水芯不承担违约责任。</li>
          </ol>
        </section>

        <section>
          <h2>九、服务调整与终止</h2>
          <p>水芯有权根据业务发展需要，对平台服务内容进行调整、暂停或终止，并在合理范围内进行公示或通知。</p>
        </section>

        <section>
          <h2>十、法律适用与争议解决</h2>
          <p>本协议适用中华人民共和国法律。因本协议产生的争议，双方应友好协商解决；协商不成的，提交水芯运营主体所在地人民法院管辖。</p>
        </section>

        <section>
          <h2>十一、其他</h2>
          <ol>
            <li>本协议构成双方关于使用本平台服务的完整协议。</li>
            <li>如本协议部分条款被认定为无效，不影响其他条款的效力。</li>
          </ol>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.legal-page {
  padding: 40px 0;
  background-color: #f9f9f9;
  min-height: 80vh;
}

.legal-content {
  background: white;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  max-width: 960px;
  margin: 0 auto;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 30px;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  border-left: 4px solid #005eb8;
  padding-left: 10px;
}

p, li {
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  margin-bottom: 10px;
}

ul, ol {
  padding-left: 20px;
  margin-bottom: 10px;
}

li {
  margin-bottom: 8px;
}
</style>
